import { ValidatorFn } from '@angular/forms';
import {
  cyprusPhoneValidator,
  separatedZipValidator,
  zipPhoneValidator,
} from '../../pages/home-page/user-profile/user-profile-general/custom-validator/zipPhone.validator';
import {
  PHONE_MASK_FOR_CYPRUS,
  PHONE_PREFIX_FOR_CYPRUS,
  ZIP_MASK_FOR_LATVIA,
  ZIP_PREFIX_FOR_LATVIA,
  ZIP_MASK_FOR_LITHUANIA,
  ZIP_PREFIX_FOR_LITHUANIA,
} from '../constants/countries.constants';
import { CountriesEnumList } from '../enums/countries.enum';

export interface CountryPhoneConfig {
  mask: string;
  prefix: string;
  validator: (regex: RegExp, prefix: string) => ValidatorFn;
  formatValue?: (value: string, prefix: string) => string;
  parseValue?: (value: string, prefix: string) => string;
}

export interface CountryZipConfig {
  mask: string;
  prefix: string;
  validator: (regex: RegExp, prefix: string) => ValidatorFn;
  formatValue?: (value: string, prefix: string) => string;
  parseValue?: (value: string, prefix: string) => string;
}

export const PHONE_CONFIGS: Record<string, CountryPhoneConfig> = {
  [CountriesEnumList.CYPRUS]: {
    mask: PHONE_MASK_FOR_CYPRUS,
    prefix: PHONE_PREFIX_FOR_CYPRUS,
    validator: cyprusPhoneValidator,
    formatValue: (value: string, prefix: string) => {
      const valueWithoutSpaces = value.replace(/\s/g, '');
      const fullValue = prefix + valueWithoutSpaces;
      return fullValue.slice(0, 2) + ' ' + fullValue.slice(2);
    },
    parseValue: (value: string, prefix: string) => {
      return value.replace(new RegExp(`^${prefix}`), '');
    },
  },
};

export const ZIP_CONFIGS: Record<string, CountryZipConfig> = {
  [CountriesEnumList.LATVIA]: {
    mask: ZIP_MASK_FOR_LATVIA,
    prefix: ZIP_PREFIX_FOR_LATVIA,
    validator: separatedZipValidator,
    formatValue: (value: string, prefix: string) => prefix + value,
    parseValue: (value: string, prefix: string) => {
      return value.replace(new RegExp(`^${prefix}`), '');
    },
  },
  [CountriesEnumList.LITHUANIA]: {
    mask: ZIP_MASK_FOR_LITHUANIA,
    prefix: ZIP_PREFIX_FOR_LITHUANIA,
    validator: separatedZipValidator,
    formatValue: (value: string, prefix: string) => prefix + value,
    parseValue: (value: string, prefix: string) => {
      return value.replace(new RegExp(`^${prefix}`), '');
    },
  },
};

export const DEFAULT_PHONE_CONFIG: Omit<CountryPhoneConfig, 'mask'> = {
  prefix: '',
  validator: zipPhoneValidator,
};

export const DEFAULT_ZIP_CONFIG: Omit<CountryZipConfig, 'mask'> = {
  prefix: '',
  validator: zipPhoneValidator,
};
